import { Body } from "@components/Typography";
import { Routes } from "@ctypes";
import { useTheme } from "@hooks";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { styles } from "./styles";
import { AddressSuggestionListProps, ListItemProps } from "./types";

export const AddressSuggestionList = ({
  data,
  flow = "residential",
}: AddressSuggestionListProps) => {
  const { theme } = useTheme();

  const hasData = data.length > 0;

  const navigate = useNavigate();

  const route =
    flow === "employer"
      ? Routes.EmployerAddressConfirmation
      : Routes.ResidentialAddressConfirmation;

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.inner,
          backgroundColor: hasData ? theme.background : "transparent",
          border: hasData ? `1px solid ${theme.border}` : "none",
        }}
      >
        {data.map((item, index) => {
          if (!item) return null;

          return (
            <ListItem
              label={item?.description}
              onClick={() =>
                navigate(route, { state: {
                  placeId: item.placeId,
                } })
              }
              style={{
                borderBottom: index !== data.length - 1 ? `1px solid ${theme.border}` : "none",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

const ListItem = ({ label, onClick, style }: ListItemProps) => {
  const { theme } = useTheme();

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  if (!label) return null;

  return (
    <div
      style={{
        ...styles.item,
        backgroundColor: isHovered ? theme.item.highlight : theme.item.background,
        ...style,
      }}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Body>{label}</Body>
    </div>
  );
};
